import { render, staticRenderFns } from "./DiplomaticVisa.vue?vue&type=template&id=21da653b&"
import script from "./DiplomaticVisa.vue?vue&type=script&lang=js&"
export * from "./DiplomaticVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports